<div class="row">
    <div class="col-sm-6">
        <h4>Lista de eventos prospetivos</h4>
    </div>
    <ng-container *ngIf="accessMP===true">
        <div class="col-sm-6 text-end">
            <a routerLink="../add" class="btn-add">
                <i class="fa fa-plus px-2"></i> Agregar nuevo
            </a>
        </div>
    </ng-container>
    <div class="container my-1">
        <div class="filter-bar row g-1 p-3">
            <div class="col-12 col-md-6">
                <input type="text" [(ngModel)]="filters.searchText" placeholder="Buscar por título o autor"
                    (input)="applyFilter()" class="form-control filter-input" />
            </div>
            <div class="col-12 col-md-3">
                <select [(ngModel)]="filters.year" (change)="applyFilter()" class="form-select filter-select">
                    <option [ngValue]="null">Todos los años</option>
                    <option *ngFor="let year of filtersAvailable.years" [ngValue]="year">
                        {{ year }}
                    </option>
                </select>
            </div>
            <div class="col-12 col-md-3">
                <select [(ngModel)]="filters.estado" (change)="applyFilter()" class="form-select filter-select">
                    <option [ngValue]="null">Todos los estados</option>
                    <option [ngValue]="true">Activo</option>
                    <option [ngValue]="false">Inactivo</option>
                </select>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Editor</th>
                    <th scope="col">Título</th>
                    <th scope="col">Autor</th>
                    <th scope="col">Fecha de publicación</th>
                    <th scope="col">Sumilla</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Contenido</th>
                    <ng-container *ngIf="accessME===true">
                        <th scope="col"></th>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true">
                        <th scope="col"></th>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let o of filteredData; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ o.ideditor }}</td>
                    <td>{{ o.title }}</td>
                    <td>{{ o.autor }}</td>
                    <td>{{ o.date }}</td>
                    <td>{{ o.content }}</td>
                    <td class="text-center">
                        <div class="label-active text-center" *ngIf="o.status">ACTIVO</div>
                        <div class="label-inactive text-center" *ngIf="!o.status">INACTIVO</div>
                    </td>
                    <td class="text-center"><a class="a-icon" [routerLink]="['/adm/contenido/list', o.id]"><i
                                class="fa fa-list i-icon"></i></a></td>
                    <ng-container *ngIf="accessME===true">
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/encuentro/edit', o.id]"><i
                                    class="fa fa-pencil i-icon"></i></a></td>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true">
                        <td class="text-center"><a class="a-icon" routerLink=""><i class="fa fa-trash i-icon"></i></a>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </div>
</div>